export default "__VITE_ASSET__BeezJorw__"